export const FREEDOM_PAY_IFRAME_ORIGIN = 'https://hpc.freedompay.com';
export const FREEDOM_PAY_UAT_IFRAME_ORIGIN = 'https://hpc.uat.freedompay.com';

export interface FreedomPayMessageInterface {
  readonly type: FreedomPayMessageType;
}

/**
 * Message type from FreedomPay
 * FreedomPay sends a message with a "type" property, these numbers need to match so cannot be changed
 * (see ConnectedFreedomPayForm - handleFreedomPayMessage)
 */
export enum FreedomPayMessageType {
  ERROR = 1,
  HEIGHT_UPDATE = 2,
  SUBMIT = 3,
  VALIDATION_UPDATE = 4,
}

export enum FreedomPaySubmitAttributeKeys {
  CARD_TYPE = 'CardIssuer',
  CARD_NUMBER = 'MaskedCardNumber',
}

export interface FreedomPaySubmitMessageAttribute {
  readonly Key: FreedomPaySubmitAttributeKeys;
  readonly Value: string;
}

/** Message sent to us on successful submit from the FreedomPay iframe */
export interface FreedomPaySubmitMessageData {
  readonly attributes: readonly FreedomPaySubmitMessageAttribute[];
  readonly paymentKeys: readonly string[];
  readonly paymentType: string;
}

/** FreedomPay data required for Galaxy's SubmitOrder request */
export interface FreedomPaySubmitPayload {
  readonly paymentKey: string;
  readonly sessionKey: string;
}

export interface FreedomPayErrorMessage extends FreedomPayMessageInterface {
  readonly type: FreedomPayMessageType.ERROR;
  readonly data: any[] | any;
}

export interface FreedomPayHeightUpdateMessage
  extends FreedomPayMessageInterface {
  readonly type: typeof FreedomPayMessageType.HEIGHT_UPDATE;
  readonly data: {
    readonly height: number;
  };
}

export interface FreedomPaySubmitMessage extends FreedomPayMessageInterface {
  readonly type: FreedomPayMessageType.SUBMIT;
  readonly data: FreedomPaySubmitMessageData;
}

export interface FreedomPayValidationUpdateMessage
  extends FreedomPayMessageInterface {
  readonly type: FreedomPayMessageType.VALIDATION_UPDATE;
  readonly data: any;
}

// create a union of the various message type. this allows TypeScript to infer what the data
// property looks like based on the type property (each message type has a different data type)
export type FreedomPayMessage =
  | FreedomPayErrorMessage
  | FreedomPayHeightUpdateMessage
  | FreedomPaySubmitMessage
  | FreedomPayValidationUpdateMessage;

export interface GetIframeV2Result {
  readonly GetIframeV2Result: string;
}

export const APIPropCode: string = 'ilv';
